import { ENDPOINT_MAP } from '../config/constants.js';
import { composeQueryParameter } from './paramHelper.js';

/**
 *
 * @param { string } domain The hosting platform's domain, used as a map's key
 * @returns The websocket URL for that domain
 * @default domain will default to our current demo WebSocket URL
 */
const getWebSocketURL = (domain) => {
    var _a;
    return (((_a = ENDPOINT_MAP[domain]) === null || _a === void 0 ? void 0 : _a.websocketProxyEndpoint) ||
        'wss://api.ws.beta.assistant.skillbuilder.training.aws.dev/' // Using Beta's WS URL for now
    );
};
/**
 *
 * @param { string } domain The hosting platform's domain, used as a map's key
 * @returns The rest URL for that domain
 * @default domain will default to our current beta rest API URL
 */
const getRestURL = (domain) => {
    var _a;
    return (((_a = ENDPOINT_MAP[domain]) === null || _a === void 0 ? void 0 : _a.restProxyEndpoint) ||
        'https://proxy.beta.assistant.skillbuilder.training.aws.dev/assistant/' // Using Beta's WS URL for now
    );
};
const generateWebSocketUrlFromInitData = (initData) => {
    const queryParameter = composeQueryParameter(initData);
    let prepend = '';
    if (queryParameter.length > 0) {
        prepend = `?${queryParameter}`;
    }
    return `${getWebSocketURL(window.location.hostname)}${prepend}`;
};

export { generateWebSocketUrlFromInitData, getRestURL, getWebSocketURL };
